const coreAssets = window.COCA_BAIS_ASSETS;

// AfOeL5-wh4NzM-7nwY1o-Q7LiO1

export default function ImagePicker(props) {
    const pickerList = props.options || [];

    return (
        <div className={"coca-image-picker"}>
            {[].map.call(pickerList, (item) => (
                <div>
                    <label
                        key={item.value}
                        className={`picker-item ${item.value === props.value ? "active" : ""} ${item.value !== "default" && props.isProFeatureEnabled === false && props.isProFeature ? "template-pro-feature" : ""}`}
                    >
                        <input
                            type="checkbox"
                            value={item.value}
                            checked={item.value === props.value}
                            onChange={(event) => {
                                if (
                                    item.value !== "default" &&
                                    props.isProFeatureEnabled === false &&
                                    props.isProFeature
                                )
                                    return;

                                props.onChange(event.target.value);
                            }}
                            className={`${item.value !== "default" && props.isProFeatureEnabled === false && props.isProFeature ? "template-pro-feature" : ""}`}
                        />
                        <img src={item.imageUrl} alt={item.label} />
                        {item.value !== "default" && props.isProFeatureEnabled === false && props.isProFeature ? (
                            <img className="picker-item__premium" src={coreAssets.icons.premium} alt="Premium Icon" />
                        ) : null}
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            className="buy-pro-overlay"
                        ></a>
                    </label>
                    {props.showLabel && <p className="picker-item__label">{item.label}</p>}
                </div>
            ))}
        </div>
    );
}
